import { MainCard } from "../../../components/Card/Cards";
import { CustomInput } from "../../../components/Input/input";
import { Button } from "primereact/button";
import { InputOtp } from "primereact/inputotp";
import React, { useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../utils/constants";

export default function EmailOtp({ step, setStep }) {
  const [isOTPSent, setIsOTPSent] = useState(false);
  const [otp, setOTP] = useState("");
  const [data, setData] = useState({
    email: "",
  });
  const [error, setError] = useState(null);

  // Validate email format
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle input change
  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // Send OTP API call
  const sendOTP = async () => {
    if (!validateEmail(data.email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      setError(null);
      const response = await axios.post(API_BASE_URL +"/api/driver/send-otp", { email: data.email });
      console.log(response.data.message);
      setIsOTPSent(true);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send OTP");
    }
  };
  
  // Verify OTP API call
  const verifyOTP = async () => {
    try {
      setError(null);
      const response = await axios.post(API_BASE_URL + "/api/driver/verify-otp", {
        email: data.email,
        otp,
      });
      console.log(response.data.message);
      const token = response.data.data.authToken; // Use the token as needed
      sessionStorage.setItem('token', token)
      setStep(0); // Proceed to the next step
    } catch (err) {
      setError(err.response?.data?.message || "Failed to verify OTP");
    }
  };

  return (
    <div>
      <h2 className="text-center">Apply Now</h2>
      <MainCard size="md:w-5 w-full">
        <div className="flex gap-3 flex-wrap align-items-center justify-content-center">
          <CustomInput
            col={12}
            type="email"
            name="email"
            label="Email Address"
            value={data.email}
            onChange={handleChange}
          />
          {isOTPSent && (
            <div className="w-full pl-2">
              <label
                className={`block mb-2 text-sm heading-color font-semibold `}
                htmlFor="otp"
              >
                Enter OTP sent on your email
              </label>
              <InputOtp
                length={6}
                integerOnly
                value={otp}
                name="otp"
                onChange={(e) => setOTP(e.value)}
                mask
              />
            </div>
          )}
          <div className="w-full pl-2">
            <Button
              label={isOTPSent ? "Verify OTP" : "Send OTP"}
              onClick={isOTPSent ? verifyOTP : sendOTP}
            />
          </div>
          {error && <p className="text-red-500">{error}</p>}
        </div>
      </MainCard>
    </div>
  );
}
